var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin_icon",
    "data-name": "Pin icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.143,
    height: 22.126,
    viewBox: "0 0 18.143 22.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 18.143,
    height: 22.126,
    transform: "translate(0 0)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M9.072,22.126C3.055,17.609,0,13.285,0,9.275l0-.3A9.044,9.044,0,0,1,9.024,0L9.36,0A9.035,9.035,0,0,1,18.141,9.26c0,4.031-3.048,8.356-9.069,12.866M8.812,1.634A7.419,7.419,0,0,0,1.634,9.293c0,3.107,2.448,6.737,7.085,10.487l.353.286.352-.286C14.06,16.036,16.51,12.4,16.51,9.275l0-.245a7.434,7.434,0,0,0-7.421-7.4h0Zm.266,9.625a2.187,2.187,0,1,1,.005,0Z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location1.71c86c7f63b55bb63e49425d808d6257.svg";
export { ForwardRef as ReactComponent };